import { MapContainer, TileLayer, ScaleControl, Marker } from "react-leaflet";
import GeneratePieChartImage from "./generatePieChartImage";
import "leaflet/dist/leaflet.css";
import LeafletMarker from "./Marker";

const MapView = (props: any) => {
  const { data } = props;
  const position: any = { lat: 40.526, lng: -100.2551 }; // Coordinates for North America

  return (
    <MapContainer center={position} zoom={4} className="!h-[93%] w-full">
      <TileLayer url="https://a.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png" />
      <ScaleControl position="bottomright" />
      {data?.map((ele: any) => (
        <LeafletMarker position={{ lat: ele.lat, lng: ele.lng }}>
          <GeneratePieChartImage data={ele} />
        </LeafletMarker>
      ))}
    </MapContainer>
  );
};

export default MapView;
